var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __rest = (this && this.__rest) || function (s, e) {
    var t = {};
    for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p) && e.indexOf(p) < 0)
        t[p] = s[p];
    if (s != null && typeof Object.getOwnPropertySymbols === "function")
        for (var i = 0, p = Object.getOwnPropertySymbols(s); i < p.length; i++) {
            if (e.indexOf(p[i]) < 0 && Object.prototype.propertyIsEnumerable.call(s, p[i]))
                t[p[i]] = s[p[i]];
        }
    return t;
};
import React from 'react';
import { txt } from './texts';
import { Dropdown } from '@sb1/ffe-dropdown-react';
import classNames from 'classnames';
export var PerPageDropdown = function (_a) {
    var locale = _a.locale, defaultValue = _a.defaultValue, setPageSize = _a.setPageSize, rowsPerPageOptions = _a.rowsPerPageOptions, className = _a.className, rest = __rest(_a, ["locale", "defaultValue", "setPageSize", "rowsPerPageOptions", "className"]);
    return (React.createElement("div", __assign({ className: classNames('ffe-pagination-rows-per-page', className) }, rest),
        React.createElement("span", { "aria-hidden": true }, txt[locale].rowsPerPageLabel[0]),
        React.createElement(Dropdown, { "aria-label": txt[locale].rowsPerPageLabel.join(' '), defaultValue: defaultValue, onChange: function (event) {
                return setPageSize(Number(event.target.value));
            } }, rowsPerPageOptions.map(function (option) { return (React.createElement("option", { key: option, value: option }, option)); })),
        React.createElement("span", { "aria-hidden": true }, txt[locale].rowsPerPageLabel[1])));
};
